export const initialState = () => {
  return {}
}

export default {
  namespaced: true,
  state: initialState(),
  getters: {},
  mutations: {
    resetState (state) {
      Object.assign(state, initialState())
    }
  },
  actions: {
    async update (context, newMapping) {
      try {
        context.commit('updateUnitTypeMapping', newMapping, { root: true })
      } catch (error) {
        console.log(error)
      }
    }
  }
}
